import { Box, HelpPanel, Link } from '@amzn/awsui-components-react';

import { FAQ_IDS } from '../../components/FAQ';
import { HelpPanelTopicOptions } from '../Constants';
import { constants } from '../Localization';
import { getUserGuidePage } from '../resourceConstants';
import DataQualityImpactBadgesHelp from './DataQualityImpactBadgesHelp';
import { HelpPanelContentFooter } from './HelpPanelContentFooter';

type MoreLinksInfo = {
    faqId: string;
    text: string;
}

const rds_recommendations_links: MoreLinksInfo[] = [
    {
        faqId: FAQ_IDS.RECOMMENDATIONS_PRIORITY_ORDER,
        text: constants.RECOMMENDATIONS_PRIORITY_ORDER,
    },
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_SQLSERVER_LI,
        text: constants.EC2_RECOMMENDATIONS_HELP_SQLSERVER_LI,
    },
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_ORACLE_BYOL,
        text: constants.EC2_RECOMMENDATIONS_HELP_ORACLE_BYOL,
    },
];

const ec2_recommendations_links: MoreLinksInfo[] = [
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_HOW,
        text: constants.EC2_RECOMMENDATIONS_HELP_HOW,
    },
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_DH,
        text: constants.EC2_RECOMMENDATIONS_HELP_DH,
    },
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_SQLSERVER_LI,
        text: constants.EC2_RECOMMENDATIONS_HELP_SQLSERVER_LI,
    },
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_ORACLE_BYOL,
        text: constants.EC2_RECOMMENDATIONS_HELP_ORACLE_BYOL,
    },
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_OVERRIDE,
        text: constants.EC2_RECOMMENDATIONS_HELP_OVERRIDE,
    },
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_PREFERENCES,
        text: constants.EC2_RECOMMENDATIONS_HELP_PREFERENCES,
    },
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_EXCLUSIONS,
        text: constants.EC2_RECOMMENDATIONS_HELP_EXCLUSIONS,
    },
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_GRAVITON,
        text: constants.EC2_RECOMMENDATIONS_HELP_GRAVITON,
    },
    {
        faqId: FAQ_IDS.EC2_RECOMMENDATIONS_TROUBLESHOOTING,
        text: constants.EC2_RECOMMENDATIONS_HELP_TROUBLESHOOTING,
    },
];

const HelpPanelContent: { [key in HelpPanelTopicOptions]: JSX.Element } = {
    adjustments_add: (
        <HelpPanel
            header={<h2>{constants.ADJUSTMENTS_ADD_HEADER}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.ADJUSTMENTS_ADD_P1}</p>
            <p>{constants.ADJUSTMENTS_ADD_EDIT_P1}</p>
            <p>{constants.ADJUSTMENTS_ADD_EDIT_P2}</p>
            <Box variant='strong'>{constants.ADJUSTMENTS_TCO_CALC_WARNING}</Box>
        </HelpPanel>
    ),
    adjustments_edit: (
        <HelpPanel
            header={<h2>{constants.ADJUSTMENTS_EDIT_HEADER}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.ADJUSTMENTS_EDIT_P1}</p>
            <p>{constants.ADJUSTMENTS_ADD_EDIT_P1}</p>
            <p>{constants.ADJUSTMENTS_ADD_EDIT_P2}</p>
            <Box variant='strong'>{constants.ADJUSTMENTS_TCO_CALC_WARNING}</Box>
        </HelpPanel>
    ),
    adjustments_view: (
        <HelpPanel
            header={<h2>{constants.ADJUSTMENTS}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.ADJUSTMENTS_VIEW_P1}</p>
            <p>{constants.ADJUSTMENTS_VIEW_P2}</p>
            <p>{constants.ADJUSTMENTS_VIEW_P3}</p>
            <Box variant='strong'>{constants.ADJUSTMENTS_TCO_CALC_WARNING}</Box>
        </HelpPanel>
    ),
    all_portfolios: (
        <HelpPanel
            header={<h2>{constants.PORTFOLIOS}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.ALL_PORTFOLIOS_P1}</p>
            <p>{constants.ALL_PORTFOLIOS_P2}</p>
            <p>{constants.ALL_PORTFOLIOS_P3}</p>
        </HelpPanel>
    ),
    application_overview: (
        <HelpPanel
            header={<h2>{constants.APPLICATION_OVERVIEW}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.APPLICATION_OVERVIEW_P1}</p>
        </HelpPanel>
    ),
    application_cost_details: (
        <HelpPanel
            header={<h2>{constants.APPLICATION_COST_DETAILS}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.APPLICATION_COST_DETAILS_P1}</p>
            <p>{constants.APPLICATION_COST_DETAILS_P2}
                <a href={getUserGuidePage('applicationCost')} target="_blank">{constants.USER_GUIDE}</a>
            </p>
        </HelpPanel>
    ),
    application_cost_summary: (
        <HelpPanel
            header={<h2>{constants.APPLICATION_COST_SUMMARY}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.APPLICATION_COST_SUMMARY_P1}</p>
            <p>{constants.APPLICATION_COST_SUMMARY_P2}</p>
            <p>{constants.APPLICATION_COST_SUMMARY_P3}
                <a href={getUserGuidePage('applicationCost')} target="_blank">{constants.USER_GUIDE}</a>
            </p>
        </HelpPanel>
    ),
    application_groups: (
        <HelpPanel
            header={<h2>{constants.APPLICATION_GROUPING_TITLE}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.APPLICATION_GRPOUPS_P1}</p>
            <p>{constants.APPLICATION_GRPOUPS_P2}</p>
            <p>{constants.APPLICATION_GRPOUPS_P3}</p>
        </HelpPanel>
    ),
    application_prioritization: (
        <HelpPanel
            header={<h2>{constants.APPLICATION_PRIORITIZATION}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.APPLICATION_PRIORITIZATION_P1}</p>
            <p>{constants.APPLICATION_PRIORITIZATION_P2}</p>
            <p>{constants.APPLICATION_PRIORITIZATION_P3}</p>
            <p>{constants.APPLICATION_PRIORITIZATION_P4}</p>
        </HelpPanel>
    ),
    application_resources: (
        <HelpPanel
            header={<h2>{constants.APPLICATION_RESOURCES}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.APPLICATION_RESOURCES_P1}</p>
            <p>{constants.APPLICATION_RESOURCES_P2}</p>
        </HelpPanel>
    ),
    assets: (
        <HelpPanel
            header={<h2>{constants.ASSETS_HEADER}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.ASSETS_P1}</p>
            <ul>
                <li>{constants.ASSETS_SERVERS}</li>
                <li>{constants.ASSETS_APPLICATIONS}</li>
                <li>{constants.ASSETS_DATABASES}</li>
                <li>{constants.ASSETS_SHARED_STORAGE}</li>
                <li>{constants.ASSETS_NETWORK}</li>
            </ul>
            <p>{constants.ASSETS_P2}</p>
            <p>{constants.ASSETS_P3}</p>
            <p>{constants.ASSETS_P4}
                <a href={getUserGuidePage('assetAttributes')} target="_blank">{constants.USER_GUIDE}</a>
            </p>
        </HelpPanel>
    ),
    aws_it_and_support: (
        <HelpPanel
            header={<h2>{constants.IT_LABOR_SUPPORT_COST}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.AWS_IT_AND_SUPPORT_HELP_P1}</p>
            <p>{constants.AWS_IT_AND_SUPPORT_HELP_P2}</p>
        </HelpPanel>
    ),
    aws_storage_and_network: (
        <HelpPanel
            header={<h2>{constants.STORAGE_NETWORK_COST}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.AWS_STORAGE_AND_NETWORK_HELP_P1}</p>
            <p>{constants.AWS_STORAGE_AND_NETWORK_HELP_P2}</p>
        </HelpPanel>
    ),
    contact_management: (
        <HelpPanel
            header={<h2>{constants.CONTACT_MANAGEMENT}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.CONTACT_MANAGEMENT_P1}</p>
            <p>{constants.CONTACT_MANAGEMENT_P2}</p>
        </HelpPanel>
    ),
    create_portfolio: (
        <HelpPanel
            header={<h2>{constants.CREATE_PORTFOLIO}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.CREATE_PORTFOLIO_P1}</p>
            <p>{constants.CREATE_PORTFOLIO_P2}</p>
            <p>{constants.CREATE_PORTFOLIO_P3}</p>
        </HelpPanel>
    ),
    data_collection: (
        <HelpPanel
            header={<h2>{constants.DATA_COLLECTION}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.DATA_COLLECTION_P1}</p>
            <p>{constants.DATA_COLLECTION_P2}</p>
            <p>{constants.DATA_COLLECTION_P3}</p>
        </HelpPanel>
    ),
    data_quality: (
        <HelpPanel
            header={<h2>{constants.VALIDATION_RULES}</h2>}
            footer={HelpPanelContentFooter({prescriptiveGuidanceDataCollection: true})}
        >
            <p>{constants.VALIDATION_RULES_P1}</p>
            <p>{constants.VALIDATION_RULES_P2}</p>
            <p>{constants.VALIDATION_RULES_P3}</p>
            <p>{constants.VALIDATION_RULES_P4}</p>
            <DataQualityImpactBadgesHelp/>
        </HelpPanel>
    ),
    data_quality_create_rule: (
        <HelpPanel
            header={<h2>{constants.CREATE_RULE}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.CREATE_RULE_P1}</p>
            <p>{constants.CREATE_RULE_P2}</p>
            <p>{constants.CREATE_RULE_P3}</p>
            <p>{constants.CREATE_RULE_P4}</p>
            <p>{constants.CREATE_RULE_P5}</p>
            <DataQualityImpactBadgesHelp/>
        </HelpPanel>
    ),
    data_quality_edit_rule: (
        <HelpPanel
            header={<h2>{constants.EDIT_RULE}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.EDIT_RULE_P1}</p>
            <p>{constants.EDIT_RULE_P2}</p>
            <p>{constants.EDIT_RULE_P3}</p>
            <DataQualityImpactBadgesHelp/>
        </HelpPanel>
    ),
    dashboards: (
        <HelpPanel
            header={<h2>{constants.DASHBOARDS}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.DASHBOARDS_P1}</p>
            <p>{constants.DASHBOARDS_P2}</p>
        </HelpPanel>
    ),
    default: (
        <HelpPanel
            header={<h2>{constants.PORTFOLIO_ASSESSMENT}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.DEFAULT_P1}</p>
            <p>{constants.DEFAULT_P2}</p>
        </HelpPanel>
    ),
    dependencies: (
        <HelpPanel
            header={<h2>{constants.DEPENDENCIES_HEADER}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.DEPENDENCIES_P1}</p>
            <ul>
                <li>{constants.DEPENDENCIES_L1}</li>
                <li>{constants.DEPENDENCIES_L2}</li>
                <li>{constants.DEPENDENCIES_L3}</li>
                <li>{constants.DEPENDENCIES_L4}</li>
            </ul>
            <p>{constants.DEPENDENCIES_P2}</p>
            <p>{constants.DEPENDENCIES_P3}</p>
            <p>{constants.DEPENDENCIES_P4}</p>
        </HelpPanel>
    ),
    ec2_cost: (
        <HelpPanel
            header={<h2>{constants.EC2_COST}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.EC2_COST_HELP_P1}</p>
            <p>{constants.EC2_COST_HELP_P2}</p>
        </HelpPanel>
    ),
    ec2_recommendations: (
        <HelpPanel
            header={<h2>{constants.EC2_RECOMMENDATIONS}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.EC2_RECOMMENDATIONS_HELP}</p>
            <p>{constants.SEE_ALSO}</p>
            {ec2_recommendations_links.map(linkInfo =>
                (<p key={linkInfo.faqId}>
                    <Link
                        href={'/faq/' + linkInfo.faqId} 
                        target='_blank'
                    >
                        {linkInfo.text}
                    </Link>
                </p>)
            )}
        </HelpPanel>
    ),
    import_from_ads: (
        <HelpPanel
            header={<h2>{constants.IMPORT_FROM_ADS}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.IMPORT_FROM_ADS_P1}</p>
            <p>{constants.IMPORT_FROM_ADS_P2}</p>
        </HelpPanel>
    ),
    import_from_file: (
        <HelpPanel
            header={<h2>{constants.IMPORT_FROM_FILE}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.IMPORT_FROM_FILE_P1}</p>
            <p>{constants.IMPORT_FROM_FILE_P2}</p>
        </HelpPanel>
    ),
    mainframe_summary: (
        <HelpPanel
            header={<h2>{constants.MAINFRAME_SUMMARY}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.MAINFRAME_SUMMARY_P1}</p>
            <p>{constants.MAINFRAME_SUMMARY_P2}</p>
            <p>{constants.MAINFRAME_SUMMARY_P3}</p>
            <p>{constants.MAINFRAME_SUMMARY_P4}</p>
        </HelpPanel>
    ),
    migration_cash_flow: (
        <HelpPanel
            header={<h2>{constants.MIGRATION_CASH_FLOW}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.MIGRATION_CASH_FLOW_P1}</p>
            <p>{constants.MIGRATION_CASH_FLOW_P2}</p>
            <p>{constants.MIGRATION_CASH_FLOW_P3}</p>
        </HelpPanel>
    ),
    migration_cost_summary: (
        <HelpPanel
            header={<h2>{constants.MIGRATION_COST_SUMMARY}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.MIGRATION_COST_SUMMARY_P1}</p>
            <p>{constants.MIGRATION_COST_SUMMARY_P2}</p>
        </HelpPanel>
    ),
    migration_strategy: (
        <HelpPanel
            header={<h2>{constants.MIGRATION_STRATEGY_HELP}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.MIGRATION_STRATEGY_HELP_P1}</p>
            <p>{constants.MIGRATION_STRATEGY_HELP_P2}</p>
            <p>{constants.MIGRATION_STRATEGY_HELP_P3}</p>
            <p>{constants.MIGRATION_STRATEGY_HELP_P4}</p>
        </HelpPanel>
    ),
    onprem_database_cost: (
        <HelpPanel
            header={<h2>{constants.ONPREM_DATABASE_COST}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.ONPREM_DATABASE_COST_P1}</p>
            <p>{constants.ONPREM_DATABASE_COST_P2}</p>
            <p>{constants.ONPREM_DATABASE_COST_P3}</p>
        </HelpPanel>
    ),
    onprem_it_labor: (
        <HelpPanel
            header={<h2>{constants.ONPREM_IT_LABOR}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.ONPREM_IT_LABOR_P1}</p>
            <p>{constants.ONPREM_IT_LABOR_P2}</p>
        </HelpPanel>
    ),
    onprem_server_cost: (
        <HelpPanel
            header={<h2>{constants.ONPREM_SERVER_COST}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.ONPREM_SERVER_COST_P1}</p>
            <p>{constants.ONPREM_SERVER_COST_P2}</p>
            <p>{constants.ONPREM_SERVER_COST_P3}</p>
        </HelpPanel>
    ),
    onprem_storage_and_network: (
        <HelpPanel
            header={<h2>{constants.ONPREM_STORAGE_AND_NETWORK}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.ONPREM_STORAGE_AND_NETWORK_P1}</p>
            <p>{constants.ONPREM_STORAGE_AND_NETWORK_P2}</p>
            <p>{constants.ONPREM_STORAGE_AND_NETWORK_P3}</p>
        </HelpPanel>
    ),
    properties: (
        <HelpPanel
            header={<h2>{constants.PROPERTIES}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.PROPERTIES_P1}</p>
            <p>{constants.PROPERTIES_P2}</p>
        </HelpPanel>
    ),
    rds_cost: (
        <HelpPanel
            header={<h2>{constants.RDS_COST}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.RDS_COST_HELP_P1}</p>
            <p>{constants.RDS_COST_HELP_P2}</p>
        </HelpPanel>
    ),
    rds_recommendations: (
        <HelpPanel
            header={<h2>{constants.RDS_RECOMMENDATIONS}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.RDS_RECOMMENDATIONS_HELP_P1}</p>
            <p>{constants.RDS_RECOMMENDATIONS_HELP_P2}</p>
            <p>{constants.RDS_RECOMMENDATIONS_HELP_P3}</p>
            <p>{constants.SEE_ALSO}</p>
            {rds_recommendations_links.map(linkInfo =>
                (<p key={linkInfo.faqId}>
                    <Link
                        href={'/faq/' + linkInfo.faqId}
                        target='_blank'
                    >
                        {linkInfo.text}
                    </Link>
                </p>)
            )}
        </HelpPanel>
    ),
    sql_server_optimization: (
        <HelpPanel
            header={<h2>{constants.SQL_SERVER_OPTIMIZATION}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.SQL_SERVER_OPTIMIZATION_P1}</p>
            <p>{constants.SQL_SERVER_OPTIMIZATION_P2}</p>
            <p>{constants.SQL_SERVER_OPTIMIZATION_P3}</p>
        </HelpPanel>
    ),
    tco_summary: (
        <HelpPanel
            header={<h2>{constants.TCO_SUMMARY}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.TCO_SUMMARY_P1}</p>
            <p>{constants.TCO_SUMMARY_P2}</p>
            <p>{constants.TCO_SUMMARY_P3}</p>
            <p>{constants.TCO_SUMMARY_P4}</p>
        </HelpPanel>
    ),
    wave_planning: (
        <HelpPanel
            header={<h2>{constants.WAVE_PLANNING_TITLE}</h2>}
            footer={HelpPanelContentFooter({})}
        >
            <p>{constants.WAVE_PLANNING_P1}</p>
            <p>{constants.WAVE_PLANNING_P2}</p>
            <p>{constants.WAVE_PLANNING_P3}</p>
        </HelpPanel>
    ),
};

export default HelpPanelContent;
